"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
var PREFIX = 'react-spectrum-';
var incrementor = 0;

var _default = function _default() {
  return PREFIX + ++incrementor;
};

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react/react-spectrum/utils/createId.js
// module id = 64
// module chunks = 0